import {
    NEW_TRANSFERENCIA_ANIMAL_SUCCESS,
    TABLE_TRANSFERENCIA_ANIMAL_PENDING,
    TABLE_TRANSFERENCIA_ANIMAL_SUCCESS,
    TABLE_TRANSFERENCIA_ANIMAL_FAILURE,
    LIST_TRANSFERENCIA_ANIMAL_PENDING,
    LIST_TRANSFERENCIA_ANIMAL_SUCCESS,
    LIST_TRANSFERENCIA_ANIMAL_FAILURE,
    FIND_TRANSFERENCIA_ANIMAL_PENDING,
    FIND_TRANSFERENCIA_ANIMAL_SUCCESS,
    FIND_TRANSFERENCIA_ANIMAL_FAILURE,
    DELETE_TRANSFERENCIA_ANIMAL_PENDING,
    DELETE_TRANSFERENCIA_ANIMAL_SUCCESS,
    DELETE_TRANSFERENCIA_ANIMAL_FAILURE,
    CREATE_TRANSFERENCIA_ANIMAL_PENDING,
    CREATE_TRANSFERENCIA_ANIMAL_SUCCESS,
    CREATE_TRANSFERENCIA_ANIMAL_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function transferenciaAnimalReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_TRANSFERENCIA_ANIMAL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_TRANSFERENCIA_ANIMAL_PENDING:
        case FIND_TRANSFERENCIA_ANIMAL_PENDING:
        case DELETE_TRANSFERENCIA_ANIMAL_PENDING:
        case CREATE_TRANSFERENCIA_ANIMAL_PENDING:
        case TABLE_TRANSFERENCIA_ANIMAL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_TRANSFERENCIA_ANIMAL_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_TRANSFERENCIA_ANIMAL_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_TRANSFERENCIA_ANIMAL_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_TRANSFERENCIA_ANIMAL_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_TRANSFERENCIA_ANIMAL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_TRANSFERENCIA_ANIMAL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_TRANSFERENCIA_ANIMAL_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_TRANSFERENCIA_ANIMAL_SUCCESS:
        case CREATE_TRANSFERENCIA_ANIMAL_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_TRANSFERENCIA_ANIMAL_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { transferenciaAnimalReducer };